export function clamp(number, min, max) {
  return Math.max(min, Math.min(number, max));
}

/* Modified to only check vertical viewport */
export function inViewport(el, threshold = 1) {
  const rect = el.getBoundingClientRect();
  const inner = window.innerHeight || document.documentElement.clientHeight;

  return (
    rect.top + (rect.height / threshold) > 0 // top
    && rect.top + (rect.height / threshold) < inner
  );
}

export function cycle(list = []) {
  return list[Math.floor(Math.random() * list.length)];
}
